// src/services/apiService.js
//const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
import { BASE_URL } from "./constant";
const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL;

export async function fetchContent(contentId) {
    const res = await fetch(`${API_BASE}/api/contents/${contentId}`);
    //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");
  
  if (!res.ok) throw new Error('Impossible de charger le contenu');
  const json = await res.json();
  // return the content object (assume json contains the record or data[0] per your API)
  return json.data ? json.data : json;
}

export async function fetchEpisode(episodeId) { 
   const res = await fetch(`${API_BASE}/api/episodes/${episodeId}`);
     //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");
  if (!res.ok) throw new Error('Impossible de charger l épisode');
  const json = await res.json();
  return json.data ? json.data[0] : json;
}

// Save watch progress (backend should accept { id, position })
export async function saveProgress({ contentId, userId, positionSeconds, durationSeconds }) {
  try {
    await fetch(`${API_BASE}/api/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contentId, userId, positionSeconds, durationSeconds }),
    });
  } catch (err) {
    console.warn('Save progress failed', err);
  }
}

// Optional: get last progress
export async function getProgress(id, userId) {
  try {
    const res = await fetch(`${API_BASE}/api/progress/${id}/${userId}`);
    if (!res.ok) return null;
    const j = await res.json();
    return j.data || null;
  } catch {
    return null;
  }
}

export async function getProgressCount(id) {
  try {
    const res = await fetch(`${API_BASE}/api/progress/count/${id}`);
    //if (!res.ok) return null;
    const j = await res.json();
    //console.log("mes api : ", res.data);
    return j.data || null;
  } catch {
    return null;
  }
}

// Save watch progress (backend should accept { id, position })
export async function saveReaction({ contentId, type, userId  }) {
  try {
    await fetch(`${API_BASE}/api/reactions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contentId, type, userId }),
    });
  } catch (err) {
    console.warn('Save reactions failed', err);
  }
}
// Save the video
export async function uploadVideo({ contentId, type, userId  }) {
  try {
    await fetch(`${API_BASE}/api/contents/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contentId, type, userId }),
    });
  } catch (err) {
    console.warn('Save reactions failed', err);
  }
}


// Optional: get last progress
export async function getStat(contentId) {
  try {
    const res = await fetch(`${API_BASE}/api/reactions/${contentId}`);
    if (!res.ok) return null;
    const j = await res.json();
    return j || null;
  } catch {
    return null;
  }
}
// Optional: get last progress
export async function getStatUser(contentId, userId) {
  try {
    const res = await fetch(`${API_BASE}/api/reactions/${contentId}/${userId}`);
    if (!res.ok) return null;
    const j = await res.json();
    return j || null;
  } catch {
    return null;
  }
}

